module.exports = __webpack_public_path__ + "static/media/Smoking.bfca36e7.svg";